module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAoCAYAAAD32nqhAAAA6UlEQVR42qXRv0dFARyG8UdERERERERERERENCQaoiEaGi4N0RANDZFOS1NLW6KlKdpaLg25crvOuel/aG2JpB/3nPM95PwNz/BZH14v1QmnBlXCsUF1xpFBnHNoEBccGMQl+wZxzZ5B3LBrELfsGMQdDYO4Z9sgmmwZxCObBtFmw6BMWTeIjDWDssuqQZmxYtSBZaOesGTULywaFBkLBsUL8wZFypxB3mXWIO8wY5CnTBv0ukwZ9DpMGvylTBj8PjFu8PPMmMF3xqjBV4sRg882wwYfTYYM3h8YNHhrMWDwekW/QZLQZ/wDD3HCHQF5BhMAAAAtdEVYdFNvZnR3YXJlAGJ5LmJsb29kZHkuY3J5cHRvLmltYWdlLlBORzI0RW5jb2RlcqgGf+4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ship-fire.png
// module id = FheX
// module chunks = 1